import { Button } from '@mui/material';
import { IconPlus } from '@tabler/icons-react';
import React from 'react';

export default function BtnPlus({ onPlusClick }) {
  return (
    <Button onClick={onPlusClick} fullWidth style={{ cursor: 'pointer' }}>
      <IconPlus />
    </Button>
  );
}
